
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useContext,
} from '@nuxtjs/composition-api';
import { getLorgarAwardShown } from '~/helpers/lsHelper';
import MainHeroAnimatedBackground from '~/domains/main/components/MainHeroAnimatedBackground';

export default defineComponent({
  name: 'HeroSection',
  components: { MainHeroAnimatedBackground },
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    link: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    modal: {
      type: Object,
      default: null,
    },
    awardsModal: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const modalRef = ref();
    const awardsModalRef = ref();
    const notificationRef = ref();
    const heroSection = ref();
    const imageElement = ref();
    const textElement = ref();
    const mountAwardsModal = ref(false);
    const { $gsap } = useContext();

    const animateOnScroll = () => {
      const instance = $gsap.matchMedia();
      instance.add('(min-width: 1024px)', () => {
        $gsap.fromTo(
          textElement.value,
          {
            y: 0,
          },
          {
            y: -50,
            ease: 'power3.out',
            scrollTrigger: {
              scrub: 1,
              trigger: heroSection.value.$el,
              start: 'top top',
              end: '40% 200px',
              toggleActions: 'restart none none reverse',
            },
          }
        );

        $gsap.fromTo(
          imageElement.value,
          {
            y: 0,
          },
          {
            y: 50,
            ease: 'power3.out',
            scrollTrigger: {
              scrub: 1,
              trigger: heroSection.value.$el,
              start: '-95 top',
              end: 'bottom 200px',
              toggleActions: 'restart none none reverse',
            },
          }
        );
      });

      instance.add('(max-width: 1023px)', () => {
        $gsap.fromTo(
          textElement.value,
          {
            y: 0,
          },
          {
            y: -20,
            ease: 'power3.out',
            scrollTrigger: {
              scrub: 1,
              trigger: heroSection.value.$el,
              start: 'top top',
              end: '50% 200px',
              toggleActions: 'restart none none reverse',
            },
          }
        );
        $gsap.fromTo(
          imageElement.value,
          {
            y: 0,
          },
          {
            y: 50,
            ease: 'power3.out',
            scrollTrigger: {
              scrub: 1,
              trigger: heroSection.value.$el,
              start: 'top top',
              end: 'bottom 200px',
              toggleActions: 'restart none none reverse',
            },
          }
        );
      });
    };

    onMounted(() => {
      mountAwardsModal.value = !getLorgarAwardShown();
      animateOnScroll();
    });

    const heroDownloads = computed(() =>
      props.modal?.files?.filter((f) => f.placeInHero)
    );

    const modalDownloads = computed(() =>
      props.modal?.files?.filter((f) => !f.placeInHero)
    );

    const openModal = () => modalRef.value.open();

    const handleOpenAwardsModal = () => {
      if (!props.awardsModal || getLorgarAwardShown()) return;
      awardsModalRef.value?.open();
    };

    const handleAwardsModalSubmit = ({ notificationText }) => {
      mountAwardsModal.value = false;
      modalRef.value?.close();
      notificationRef.value?.open(notificationText);
    };

    return {
      modalRef,
      awardsModalRef,
      notificationRef,
      heroSection,
      imageElement,
      textElement,
      mountAwardsModal,
      heroDownloads,
      modalDownloads,
      openModal,
      handleOpenAwardsModal,
      handleAwardsModalSubmit,
    };
  },
});
